import { signal } from '@preact/signals-react'

export const machineStatusSignal = signal({})
export const machineStatusLoadedSignal = signal(false)
export const machineStatusErrorSignal = signal(null)